import React from 'react'
import values from 'mout/object/values'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText';
import CompositeSegment from '../CompositeSegment'


export default function CompositeDonut({studentScore, subtests}) {
  const subs = sortByPropText(values(subtests), 'displayName')
  const { scoring } = studentScore
  const { bySubtest, byTest } = scoring
  let strokeDashoffset = 25
  return (
    <div className="Composite DonutChart">
			<svg width="100%" height="100%" viewBox="0 0 42 42" className="donut">
				<defs>
					<radialGradient id="english-radial" fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
						<stop offset="0%" stopColor="#a6579d" stopOpacity="1" />
						<stop offset="20%" stopColor="#de4997" stopOpacity="1" />
					</radialGradient>

					<radialGradient id="math-radial" fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
						<stop offset="0%" stopColor="#dc5850" stopOpacity="1" />
						<stop offset="50%" stopColor="#e66c46" stopOpacity="1" />
					</radialGradient>

					<radialGradient id="reading-radial" fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
						<stop offset="0%" stopColor="#95d6ef" stopOpacity="1" />
						<stop offset="50%" stopColor="#53b7c2" stopOpacity="1" />
					</radialGradient>

					<radialGradient id="science-radial" fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
						<stop offset="0%" stopColor="#c5da8c" stopOpacity="1" />
						<stop offset="70%" stopColor="#84b44d" stopOpacity="1" />
					</radialGradient>

				</defs>

				<circle className="DonutRing" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#d2d3d4" strokeWidth="5"></circle>
        {
          subs.map(({displayName, setId}) => {
            const score = Math.round(bySubtest[setId].scale * 10) / 10
            const compositeFilledIn = Math.round(score / 36 * 100 / 4)
            const compositeNotFilledIn = 100 - compositeFilledIn
            strokeDashoffset -= compositeFilledIn
            return (
              <CompositeSegment 
                displayName={displayName}
                compositeFilledIn={compositeFilledIn}
                compositeNotFilledIn={compositeNotFilledIn}
                strokeDashoffset={strokeDashoffset + compositeFilledIn}
                key={`compositeSegment${displayName}`}
              />
            )
          })
        }

				<circle className="DonutShadow" cx="21" cy="21" r="14" fill="transparent" stroke="rgba(0,0,0,0.07)" strokeWidth="1"></circle>
			</svg>
			<div className="ChartText">
				<p className="ChartNumber">
					{Math.round(byTest.scale * 10) / 10}
				</p>
				<p className="ChartLabel">
					Composite
				</p>
			</div>
		</div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/CompositeDonut.js